import { createFileRoute } from '@tanstack/react-router';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Spinner } from '@repo/components';
import LogsTab from 'src/parts/tabs/LogsTab';
import { getProjectLogs } from 'src/api/personal/projects';
import { startOfDay, subMonths, endOfDay } from 'date-fns';

interface LogsSearch {
	from?: string;
	until?: string;
	page?: number;
	sort?: string;
}

export const Route = createFileRoute('/personal_/projects/$projectId/logs')({
	validateSearch: (search: Record<string, unknown>): LogsSearch => {
		const now = new Date();
		return {
			from: (search.from as string) || startOfDay(subMonths(now, 1)).toISOString(),
			until: (search.until as string) || endOfDay(now).toISOString(),
			page: search.page as number | undefined,
			sort: search.sort as string | undefined,
		};
	},
	component: LogsPage,
});

function LogsPage() {
	const { projectId } = Route.useParams();
	const { from, until, page, sort } = Route.useSearch();
	const queryClient = useQueryClient();

	const { data: logs, isLoading } = useQuery({
		queryKey: ['personal-project-logs', projectId, from, until, page, sort],
		queryFn: () => getProjectLogs(projectId, { from, until, page, sort }),
	});

	const handleReload = () => {
		queryClient.invalidateQueries({ queryKey: ['personal-project-logs', projectId] });
	};

	if (isLoading) {
		return (
			<div className="h-full w-full flex items-center justify-center p-8">
				<Spinner />
			</div>
		);
	}

	return <LogsTab showFilter={false} logType="ProjectLog" logs={logs} onReload={handleReload} />;
};
